module.exports = {
  ADMIN_ROLE_SLUG: "super_admin",
  CRYPTO_SECRET_KEY: "ztohxhkzvgxzjxgyzzmg",
  API_URL: process.env.REACT_APP_BACKEND_API_URL,
  SERVER_FILE_PATH: process.env.REACT_APP_SERVER_FILE_PATH,
  ADMIN_EMAIL: process.env.REACT_APP_ADMIN_EMAIL,
};
